// A refusal on the Pipeline, the slate, the HM review and the Step 8–9 cards is his rule sentence, looked up by the
// refusal's rule code; the server's detail text is never rendered. tests/mc/b3-pipeline.test.mjs reads every rule code
// the slate, decision and screen-outcome tools raise and proves each has a sentence here.

import { AppError } from "@/api/runtime";
import { G1_LABELS, G6_RULE_LABELS, RULE_LABELS, SCREEN_LABELS } from "@/mc";
import { BRD } from "@/views/candidate/brd";
import { PROFILE_RULES } from "@/views/candidate/labels";
import { ruleCode } from "@/views/candidate/refusals";
import { PIPELINE_RULES } from "./labels";

/** Rule code → his sentence. */
export const PIPELINE_REFUSALS: Readonly<Record<string, string>> = {
  // the slate (candidate.batch_assemble / batch_send)
  read_required: PIPELINE_RULES.slate,
  attestation_required: PROFILE_RULES.attestation,
  requisition_not_posted: PIPELINE_RULES.slate,
  intake_not_finalized: PIPELINE_RULES.slate,
  sourcing_unavailable: PIPELINE_RULES.slate,
  requisition_status: BRD.links,
  recruiter_unassigned: G6_RULE_LABELS.taManagerAssigns,
  // the HM's decisions (candidate.decide_resume / batch_decide / screen.decide)
  disposition_reason_required: PIPELINE_RULES.passNeedsReason,
  reason_code: PIPELINE_RULES.passNeedsReason,
  reason_required: G1_LABELS.requireReason,
  note_required: G1_LABELS.requireReason,
  reason: G1_LABELS.requireReason,
  reason_inactive: G1_LABELS.requireReason,
  hold_reason_required: G1_LABELS.requireReason,
  decision_required: PIPELINE_RULES.retainAdvanceHoldPass,
  batch_decided: PIPELINE_RULES.heldAge,
  stage: PIPELINE_RULES.retainAdvanceHoldPass,
  two_: PIPELINE_RULES.retainAdvanceHoldPass, // "two_2s": the rule-code reader stops at the digit
  conduct_concern_open: PIPELINE_RULES.retainAdvanceHoldPass,
  next_stage_booked: PIPELINE_RULES.retainAdvanceHoldPass,
  // the Recruiter screen card (screen.save_form / screen.record_outcome)
  screen_not_held: SCREEN_LABELS.chain,
  outcome_recorded: PIPELINE_RULES.recruiterRecords,
  withdrawal_required: RULE_LABELS.withdrawalRequires,
  withdrawal_stage: RULE_LABELS.withdrawalRequires,
  form_incomplete: PIPELINE_RULES.recruiterOwns,
  scorecard_not_submitted: PIPELINE_RULES.recruiterOwns,
};

/** His sentence for a 4xx refusal, or null when the refusal is not a rule (a 5xx or a lost connection is an error). */
export function pipelineRefusal(error: unknown): string | null {
  if (!(error instanceof AppError) || error.status < 400 || error.status >= 500) return null;
  const code = ruleCode(error);
  return (code && PIPELINE_REFUSALS[code]) || PIPELINE_RULES.retainAdvanceHoldPass;
}
